<template>
  <div class="shortcuts-row">
    <div class="shortcuts-keys">
      <!-- Key(s) -->
      <slot name="key"></slot>
    </div>
    <div class="shortcuts-description">
      <!-- Action description -->
      <slot name="description"></slot>
    </div>
  </div>
</template>

<script>
// @group Dialog
// Shortcut description row
export default {
  name: "ShortcutRow"
};
</script>

<style scoped>
.shortcuts-row {
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 0.4em;
  border-radius: 5px;

  /** transition */
  transition: background-color 0.5s;
}

.shortcuts-keys {
  margin-right: 2em;
  font-weight: bold;
  white-space: nowrap;
}

.shortcuts-description {
  text-align: end;
}
</style>
